import { useApp } from "@/AppProvider"
import { PaperAirplaneIcon, ShareIcon } from "@heroicons/react/24/outline"
import { Dispatch, SetStateAction } from "react"
import { LabReport } from "../../types/LabReport"
import { Tooltip } from "../common/Tooltip"

interface Props {
  results: LabReport
  setIsEmailEditorOpen: Dispatch<SetStateAction<boolean>>
  setIsShareModalOpen: Dispatch<SetStateAction<boolean>>
}

export const ResultsHeader = ({ results, setIsEmailEditorOpen, setIsShareModalOpen }: Props) => {
  const { isAnonymous } = useApp()

  return (
    <div className="card -mt-8 flex items-center justify-between rounded-none py-1.5 md:rounded-b">
      <div className="flex flex-col items-baseline gap-x-2 sm:flex-row">
        <h2 className="max-w-[60ch] truncate text-lg font-semibold text-gray-900">{results.description}</h2>
        <p className="text-xs font-medium text-gray-500">
          {results.resultsUpdatedAt
            ? new Intl.DateTimeFormat("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              }).format(new Date(results.resultsUpdatedAt))
            : null}
        </p>
      </div>
      {!isAnonymous && (
        <div className="flex items-center gap-x-2">
          <Tooltip content="Share">
            <button
              onClick={() => setIsShareModalOpen(true)}
              className="focus-visible:ring-primary-600 rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1">
              <ShareIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
              <span className="sr-only">Share</span>
            </button>
          </Tooltip>
          <Tooltip content="Send message">
            <button
              onClick={() => setIsEmailEditorOpen(true)}
              className="focus-visible:ring-primary-600 rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1">
              <PaperAirplaneIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
              <span className="sr-only">Send message</span>
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  )
}
